<template>
    <div style='height: 100%'>
        <div class="page-content">
            <div class="query">
                <el-form
                    label-width="80px"
                    :inline="true"
                    size="small"
                    class="query-form"
                >
                    <el-form-item
                        label="报表类型"
                    >
                        <el-select
                            style="width:200px"
                            v-model="reportDataType"
                            size="small"
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="(item,index) in reportDataTypeEnumList"
                                :key="index"
                                :label="item.value"
                                :value="item.key"
                            > </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label="所属店铺"
                    >
                        <!--                        <el-select-->
                        <!--                            style="width:200px"-->
                        <!--                            v-model="storeId"-->
                        <!--                            size="small"-->
                        <!--                            placeholder="请选择"-->
                        <!--                        >-->
                        <!--                            <el-option-->
                        <!--                                v-for="(item,index) in reportDataTypeEnumList"-->
                        <!--                                :key="index"-->
                        <!--                                :label="item.value"-->
                        <!--                                :value="item.key"-->
                        <!--                            > </el-option>-->
                        <!--                        </el-select>-->
                        <GridSelectLi
                            style="width: 177px"
                            title="选择店铺"
                            labelName="shopName"
                            labelValue="id"
                            :value="shopId"
                            :limit="1"
                            size="small"
                            placeholder="请选择店铺"
                            @getValue="getSearchValueStoreId"
                            :columns="SHOP_code"
                            :searchs="SHOP_search"
                            dataListUrl="/mall/shop/findList"
                            entityBeanName="mallShop"
                            queryEntityUrl="/mall/shop/get"
                        >
                        </GridSelectLi>
                    </el-form-item>
                    <!-- <el-form-item
                        label="商品类型"
                    >
                        <el-select
                            style="width:200px"
                            v-model="productType"
                            size="small"
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="(item,index) in productTypeEnumList"
                                :key="index"
                                :label="item.value"
                                :value="item.key"
                            > </el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item>
                        <el-button size="small" type="primary" icon="el-icon-search" @click="getData">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" @click="resetData()">重置</el-button>
                        <el-button size="small" type="primary" @click="openIsShow">报表数据</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="chart">
                <div class="my-charts" ref="saleroom"></div>
                <div class='time-box'>
                    <span :style='{ color:saleroomTimeType == 1 ? "#409EFF" : "#717171" }' @click='getSaleroom(1)'>七天</span>
                    <span :style='{ color:saleroomTimeType == 2 ? "#409EFF" : "#717171" }' @click='getSaleroom(2)'>一月</span>
                    <span :style='{ color:saleroomTimeType == 3 ? "#409EFF" : "#717171" }' @click='getSaleroom(3)'>一年</span>
                </div>
            </div>
        </div>
        <el-drawer title="报表数据" :visible.sync="isShow" direction="rtl" size="70%"
                   :before-close="closeIsShow">
            <ReportDaily ref="reportDaily" />
        </el-drawer>
    </div>
</template>
<script>
import * as echarts from 'echarts';
import { get } from '@/utils/request';
import ReportDaily from '@/components/report/ReportDailyShop.vue';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import { SHOP, SHOP_SEARCH } from '@/utils/constant';

export default {
    components: { GridSelectLi, ReportDaily },
    data(){
        return{
            statementName:'',
            saleroomTimeType:1, // 销售额周月年
            quantityTimeType:1, // 销售量周月年
            // productType:1, // 商品类型
            productTypeEnumList:[],
            reportDataType:1, // 报表类型
            shopId: '',
            reportDataTypeEnumList:[],
            isShow: false,
            SHOP_code: SHOP,
            SHOP_search: SHOP_SEARCH,
        }
    },
    mounted(){
        this.getProductTypeEnum()
        this.getReportDataTypeEnum()
        this.getSaleroom()
    },
    methods:{
        openIsShow(){
            this.isShow = true;
            this.$nextTick(()=>{
                this.$refs.reportDaily.init()
            })
        },

        getSearchValueStoreId(value) {
            this.shopId = value;
        },

        closeIsShow(){
            this.isShow = false
            this.getSaleroom()
        },

        // 获取销售金额
        getSaleroom(timeType = 1){
            get('/report/reportdailyshop/findListByType',{
                dataTypes:this.reportDataType,
                shopId:this.shopId,
                timeType,
                // productType: this.productType,
            }).then((res)=>{
                if(res.success && res.code == 200){
                    this.statementName = this.reportDataTypeEnumList[this.reportDataType-1].value
                    this.saleroomTimeType = timeType
                    this.lineSaleroom(res.list[0])

                }
            })
        },

        // 销售金额折线图
        lineSaleroom(list) {
            let saleroom = echarts.init(this.$refs.saleroom);
            saleroom.setOption({
                tooltip: {
                    trigger: 'axis'
                },
                title:{
                    text:this.statementName
                },
                // toolbox: {
                //     feature: {
                //         saveAsImage: {}
                //     },
                //     right:'30rpx'
                // },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: list.map((item) => item.timeX)
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '有效',
                        type: 'line',
                        stack: 'Total',
                        data: list.map((item) => item.valueY)
                    }
                ]
            })
        },

        //  获取商品类型枚举
        getProductTypeEnum(){
            get('/report/utils/getEnum',{
                enumType: 'report_data_type_product_enum',
            }).then((res)=>{
                if(res.success){
                    this.productTypeEnumList = res.enumList
                }
            })
        },

        //  获取报表类型枚举
        getReportDataTypeEnum(){
            get('/report/utils/getEnum',{
                enumType: 'report_data_type_shop_enum',
            }).then((res)=>{
                if(res.success){
                    this.reportDataTypeEnumList = res.enumList
                    this.statementName = res.enumList[0].value
                }
            })
        },

        // 查询
        getData(){
            this.getSaleroom()
        },
        // 重置
        resetData(){
            this.saleroomTimeType = 1
            this.quantityTimeType = 1
            this.shopId = ''
            // this.productType = 1
            this.reportDataType = 1
            this.getData()
        },

    }
}

</script>
<style lang="scss" scoped>
.page-content{
    height: 100%;
    padding: 10px;
    background-color: #fff;

    .query{
        width: 100%;
    }


    .chart{
        margin: auto 0;
        position: relative;
        width: 100%;
        height: 440px;
        padding: 0 22px;
        .my-charts{
            width: 100%;
            height: 100%;
        }
        .time-box{
            position: absolute;
            top: 0;
            right: 35px;
            width: 180px;
            height: 40px;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            span{
                font-size: 14px;
                cursor: pointer;
            }
        }
    }
}
</style>
